import styled from 'styled-components';

import { FormInput, units } from '@calm-web/design-system';

export const Input = styled(FormInput)`
	margin-bottom: ${units(3)};
`;
